// @ts-strict-ignore
import React from 'react';
import { MultiSelect } from '@usealloy/component-library';
import { CountryRegionData } from 'react-country-region-selector';
import styled from 'styled-components';

const SelectWrapper = styled.div`
  max-width: max-content;
`;

interface AddressCountryCodeSelectProps {
  fieldKey: string;
  formData: Record<string, any>;
  handleCountryFieldChange: (selectedOption: { label: string; value: string }) => void;
}

const AddressCountryCodeSelect: React.FC<AddressCountryCodeSelectProps> = (
  { fieldKey, formData, handleCountryFieldChange },
) => {
  const usaDefault = CountryRegionData.find(country => country[1] === 'US');
  const fieldValue = formData[fieldKey];
  const fieldValueLabel = typeof fieldValue === 'string' ? fieldValue.toUpperCase() : fieldValue;

  return (
    <SelectWrapper>
      <MultiSelect
        isMulti={false}
        placeholder="Country"
        options={[
          { label: usaDefault[0], value: usaDefault[1] },
          ...CountryRegionData.map(country => ({
            label: country[0],
            value: country[1],
          })),
        ]}
        selectedOptions={
          fieldValue
            ? {
              label: CountryRegionData.find(country => country[1] === fieldValueLabel)[0],
              value: fieldValue,
            }
            : null
        }
        onChange={handleCountryFieldChange}
      />
    </SelectWrapper>
  );
};

export default AddressCountryCodeSelect;
